/* eslint-disable no-restricted-imports */
import React, { useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useCouponContext } from "./CouponDataContext";

export function CouponShowDialog({
  history,
  id,
  show,
  onHide,
  setShowSuccessOpen,
  setShowErrorOpen,
}) {
  const context = useCouponContext();
  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const showCoupon = async () => {
    const couponShowUrl = "api/discounts/show/";
    const result = await axios.patch(couponShowUrl + id);
    if (result.data === "success") {
      //console.log("marked to show coupon");
      setShowSuccessOpen(true);
      context.setRefetch(true);
      setTimeout(() => {
        history.push("/coupons/coupon-list");
      }, 1000);
    } else {
      //console.log(result.data);
      setShowErrorOpen(true);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/* {isLoading && <ModalProgressBar variant="query" />} */}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">Show Coupon</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>Are you sure you want to show this coupon?</span>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={showCoupon}
            className="btn btn-delete btn-elevate"
          >
            Show Coupon
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
